var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{attrs:{"wrapClass":"scrollbar-wrapper"}},[_c('el-menu',{attrs:{"mode":"vertical","show-timeout":200,"default-active":_vm.$route.path,"collapse":_vm.isCollapse,"background-color":"#394158","text-color":"#8FADD5","active-text-color":"#fff","unique-opened":true}},[_c('sidebar-item',{attrs:{"routes":_vm.permission_routers}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }